export default "__VITE_ASSET__BCO7MA2r__"